import { render, staticRenderFns } from "./FamiliasDialog.vue?vue&type=template&id=7452609a&"
import script from "./FamiliasDialog.vue?vue&type=script&lang=js&"
export * from "./FamiliasDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports